import { ArrowLongRightIcon, PhoneIcon } from "@heroicons/react/24/solid";
import { motion } from "framer-motion";
import Link from "next/link";
import { Icons8RegisterSimple } from "~/src/components/icons";
import { getContactInfo } from "~/utils/contactInfo";

interface ContactButtonsProps {
  className?: string;
  isMobile?: boolean;
  showBookingButton?: boolean;
}

const ContactButtons: React.FC<ContactButtonsProps> = ({
  isMobile,
  showBookingButton = true,
}) => {
  const { phoneNumber, phoneHref } = getContactInfo();

  if (!phoneHref && !showBookingButton) {
    return null;
  }

  if (isMobile) {
    return (
      <div className="flex items-center gap-2">
        {phoneHref && (
          <motion.a
            href={phoneHref}
            whileTap={{ scale: 0.95 }}
            className="flex h-12 w-12 items-center justify-center rounded-full border-2 border-[#0C1F3F] bg-white text-[#0C1F3F] shadow-sm transition-all duration-300 hover:bg-[#0C1F3F] hover:text-white hover:shadow-md"
            title="Zadzwoń"
          >
            <PhoneIcon className="h-5 w-5" />
          </motion.a>
        )}

        {showBookingButton && (
          <motion.div whileTap={{ scale: 0.95 }}>
            <Link
              href="/zarezerwuj-przeglad/"
              className="flex h-12 w-12 items-center justify-center rounded-full bg-[#FF6B35] text-white shadow-md transition-all duration-300 hover:bg-[#E85A25] hover:shadow-lg"
              title="Zarezerwuj Przegląd"
            >
              <Icons8RegisterSimple className="h-5 w-5" />
            </Link>
          </motion.div>
        )}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3">
      {phoneHref && (
        <motion.a
          href={phoneHref}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className="flex h-11 items-center gap-2 rounded-lg border-2 border-[#0C1F3F] bg-white px-4 text-sm font-semibold text-[#0C1F3F] shadow-sm transition-all duration-300 hover:bg-[#F7F8FA] hover:text-[#0C1F3F] hover:shadow-md"
          title="Zadzwoń"
        >
          <PhoneIcon className="h-5 w-5" />
          <span>{phoneNumber}</span>
        </motion.a>
      )}

      {showBookingButton && (
        <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
          <Link
            href="/zarezerwuj-przeglad/"
            className="group relative flex h-11 items-center gap-2 overflow-hidden rounded-lg bg-[#FF6B35] px-5 text-sm font-semibold text-white shadow-md transition-all duration-300 hover:bg-[#E85A25] hover:shadow-lg"
            title="Zarezerwuj Przegląd"
          >
            <span className="relative z-10 transition-transform duration-300 group-hover:-translate-x-1">
              Rezerwuj
            </span>
            <ArrowLongRightIcon className="relative z-10 h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </motion.div>
      )}
    </div>
  );
};

export default ContactButtons;
